var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-package-strip"},[_c('div',{staticClass:"touch-strip",on:{"click":_vm.showPackagePopup}},[_vm._m(0),_c('i',{staticClass:"arrow"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("选择"),_c('span',[_vm._v("商品类型/数量")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f2b0b86","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./libs/components/detail/Package.vue
// module id = 735
// module chunks = 0